<template>
  <div>
    <el-page-header class="detail-head" @back="goBack">
      <template v-slot:content>
        <div class="toolbar">
          <span>订单详情</span>
          <div class="toolbar-items">
            <el-button size="mini" type="success" @click="audit">审核</el-button>
            <el-button size="mini" type="primary" @click="exportExcel">导出Excel</el-button>
          </div>
        </div>
      </template>
    </el-page-header>

    <el-divider class="detail-divider"></el-divider>
    <el-tabs>
      <el-tab-pane label="订单信息">
        <div class="detail-containe-product">
          <el-scrollbar>
            <el-form class="detail-form" ref="mainForm" :model="entity" :rules="rules" label-width="100px">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="订单编码" class="detail-form-item" prop="code">
                      <el-input size="medium" v-model="entity.code"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="用户名称" class="detail-form-item">
                      <el-input size="medium" v-model="entity.user.realName" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="大客户折扣" class="detail-form-item">
                      <el-input size="medium" v-model="entity.user.discount" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="订单状态" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.state">
                        <el-option v-for="item in states" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="商品总数量" class="detail-form-item">
                      <el-input size="medium" v-model="entity.orderQuantity" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="商品销售金额" class="detail-form-item">
                      <el-input size="medium" v-model="entity.saleMoney" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="优惠金额" class="detail-form-item">
                      <el-input size="medium" v-model="entity.reducedMoney" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="订单金额" class="detail-form-item">
                      <el-input size="medium" v-model="entity.orderMoney" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="运费金额" class="detail-form-item">
                      <el-input size="medium" v-model="entity.freightMoney"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="应付总金额" class="detail-form-item">
                      <el-input size="medium" v-model="entity.payMoney"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="提交时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.submitTime" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="审核时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.verifyTime" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="取消时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.cancelTime" readonly></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.creator" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.createTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifier" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifyTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <div class="grid-content">
                    <el-form-item label="备注" class="detail-form-item">
                      <el-input type="textarea" v-model="entity.remark"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="订单商品详情">
        <div class="detail-containe-product">
          <el-scrollbar>
            <el-table ref="tableOrder" :data="entity.orderDetails" border style="width: 100%" stripe>
              <el-table-column prop="product.name" label="产品名称" width="300">
              </el-table-column>
              <el-table-column prop="product.code" label="产品编号" width="200">
              </el-table-column>
              <el-table-column prop="product.nominal" label="标准值" width="120">
              </el-table-column>
              <el-table-column prop="product.spec" label="规格">
              </el-table-column>
              <el-table-column prop="product.platformState" label="货期" width="120">
              </el-table-column>
              <el-table-column prop="product.salePrice" label="标准价" width="120">
              </el-table-column>
              <el-table-column prop="memberPrice" label="会员价" width="120">
              </el-table-column>
              <el-table-column prop="quantity" label="数量" width="120">
              </el-table-column>
              <el-table-column prop="subtotalMoney" label="小计" width="120">
              </el-table-column>
            </el-table>
          </el-scrollbar>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { Order } from "@/script/apps/shop/entity/ShopEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DictUtil } from "@/script/core/Dict";
import { OrderService } from "@/script/apps/shop/service/OrderService";
import { ElMessage, ElMessageBox } from "element-plus";
import { AppConfig } from "@/script/core/base/AppConfig";
import axios from "axios";

@Options({})
export default class OrderDetail extends BaseDetail {
  private service = new OrderService();

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_shop_order",
      "/shop/order",
      "/shop/order",
      this.service
    );
    data.entity = {
      user: { realName: "" },
    };
    data.statesName = "shop-order-state";
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入编码", trigger: "blur" }],
    name: [{ required: true, message: "请输入名称", trigger: "blur" }],
  };

  public newEntity() {
    const entity: Order = {};
    return entity;
  }

  private audit() {
    ElMessageBox.confirm("此操作将[审核订单], 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        const order = this.entity as Order;
        this.service.action(
          "/api/shop/order/audit",
          order,
          (data: any) => {
            ElMessage({ type: "success", message: data.message });
            this.load(this.id);
          },
          function (error: Error) {
            ElMessage.error(error.message);
          }
        );
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消操作",
        });
      });
  }

  private exportExcel() {
    const self = this;
    const fileName = "标物订单-" + self.entity.code + ".xlsx";
    this.service
      .exportExcel(
        "/api/shop/order/excel/export",
        { id: this.entity.id },
        fileName
      )
      .then(
        function (status: any) {
          
        },
        function (error: Error) {
          console.error(error);
        }
      );
  }
}
</script>

<style lang="scss">
</style>
